
import { createSlice} from "@reduxjs/toolkit";
const inviteWorkerCsvView = createSlice({
  name: 'inviteWorkerCsvView',
      initialState:{
        data:null,
        loading:false,
        error:null,
    },
  reducers: {
    fetchData: (state) => {
      state.loading = true;
    },
    fetchDataSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    fetchDataError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    reSetData:()=>{
      return {
        data:null,
        loading:false,
        error:null,
    }
    }
  },
});
export const { fetchData, fetchDataSuccess, fetchDataError,reSetData } = inviteWorkerCsvView.actions;
export default inviteWorkerCsvView.reducer;